var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDropDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 4,
  fill: "#fff",
  rx: 2
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 3,
  x: 0.5,
  y: 7.469,
  fill: "#CCC",
  stroke: "#CCC",
  rx: 1.5
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 3,
  x: 0.5,
  y: 14.469,
  fill: "#CCC",
  stroke: "#CCC",
  rx: 1.5
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 3,
  x: 7.5,
  y: 0.5,
  fill: "#CCC",
  stroke: "#CCC",
  rx: 1.5
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 3,
  x: 7.5,
  y: 7.469,
  fill: "#CCC",
  stroke: "#CCC",
  rx: 1.5
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 3,
  x: 7.5,
  y: 14.469,
  fill: "#CCC",
  stroke: "#CCC",
  rx: 1.5
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 3,
  x: 14.5,
  y: 0.5,
  fill: "#CCC",
  stroke: "#CCC",
  rx: 1.5
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 3,
  x: 14.5,
  y: 7.469,
  fill: "#CCC",
  stroke: "#CCC",
  rx: 1.5
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 3,
  x: 14.5,
  y: 14.469,
  fill: "#CCC",
  stroke: "#CCC",
  rx: 1.5
})));
export default SvgDropDown;